export const zileLibere = [
  new Date("2024-10-05"),
  new Date("2024-11-30"),
  new Date("2024-12-01"),
  new Date("2024-12-25"),
  new Date("2024-12-26"),
  new Date("2025-01-01"),
  new Date("2025-01-02"),
  new Date("2025-01-06"),
  new Date("2025-01-07"),
  new Date("2025-01-24"),
  new Date("2025-01-24"),
  new Date("2025-04-18"),
  new Date("2025-04-21"),
  new Date("2025-04-22"),
  new Date("2025-05-01"),
  new Date("2025-05-02"),
  new Date("2025-06-05"),
  new Date("2025-06-09"),
  new Date("2025-08-15"),
];

export const recuperari = [new Date("2025-05-02")];

export const vacante1 = [
  { s: new Date("2024-10-26"), e: new Date("2024-11-03") },
  { s: new Date("2024-12-21"), e: new Date("2025-01-07") },
  { s: new Date("2025-02-10"), e: new Date("2025-02-17") },
  { s: new Date("2025-04-18"), e: new Date("2025-04-27") },
  { s: new Date("2025-06-21"), e: new Date("2025-09-07") },
];
export const activitateInScoala = [
  { s: new Date("2025-09-01"), e: new Date("2025-09-05") },
];

export const vacante2 = [
  { s: new Date("2024-10-26"), e: new Date("2024-11-03") },
  { s: new Date("2024-12-21"), e: new Date("2025-01-07") },
  { s: new Date("2025-02-17"), e: new Date("2025-02-21") },
  { s: new Date("2025-04-18"), e: new Date("2025-04-27") },
  { s: new Date("2025-06-21"), e: new Date("2025-09-07") },
];
export const getVacante = () => {
  if (process.env.REACT_APP_NAME === "SGMVT") return vacante2;
  else return vacante1;
};
